var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inventory--documents-tab animated fadeIn"},[_c('Documents',{attrs:{"parentId":_vm.partId,"service":_vm.documentsService,"fileTypes":_vm.fileTypes}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }